import React, { useState, useEffect } from 'react';
import selfie from '../images/selfie.jpg';

const TAGLINE = "Software Developer · Montreal, Canada";
const CURSOR_BLINK_COUNT = 5;

const Hero = () => {
  const [displayed, setDisplayed] = useState('');
  const [phase, setPhase] = useState('typing'); // 'typing' | 'blinking' | 'done'

  useEffect(() => {
    let i = 0;
    const timer = setInterval(() => {
      if (i < TAGLINE.length) {
        setDisplayed(TAGLINE.slice(0, i + 1));
        i++;
      } else {
        setPhase('blinking');
        clearInterval(timer);
      }
    }, 28);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="home" className="hero">
      <div className="container">
        <img src={selfie} alt="Nicolo Tabar" className="hero-photo" />
        <h1 className="hero-name">Nicolo Tabar</h1>
        <p className="hero-tagline">
          {displayed}
          <span
            className={phase === 'blinking' ? 'cursor cursor-blink-once' : 'cursor'}
            style={{
              ...(phase === 'blinking' ? { animationIterationCount: CURSOR_BLINK_COUNT } : {}),
              ...(phase === 'done' ? { visibility: 'hidden' } : {}),
            }}
            onAnimationEnd={phase === 'blinking' ? () => setPhase('done') : undefined}
          >|</span>
        </p>
          <a
            href="https://www.linkedin.com/in/nicolo-tabar/"
            target="_blank"
            rel="noreferrer"
            className="contact-btn"
          >
            Contact Me
          </a>
      </div>
    </section>
  );
};

export default Hero;
